import { useIsFetching } from "@tanstack/react-query";
import { Box } from "@mantine/core";

export function PageLoader() {
  const isFetching = useIsFetching();

  if (!isFetching) return null;

  return (
    <Box
      pos="fixed"
      top={0}
      left={0}
      right={0}
      style={{ zIndex: 50, height: 2, overflow: "hidden" }}
    >
      <Box
        h="100%"
        w="100%"
        bg="var(--mantine-primary-color-filled)"
        style={{ animation: "nodus-progress-bar 1.5s ease-out infinite" }}
      />
      <style>{`
        @keyframes nodus-progress-bar {
          0%   { transform: translateX(-100%); }
          50%  { transform: translateX(-10%); }
          100% { transform: translateX(0%); }
        }
      `}</style>
    </Box>
  );
}
